Ext.define('SA.SvgTextRenderer', {
    singleton: true,

    renderElement(dstEl, el, {left = 0, top = 0, baselineOffset = '0.75em', textAnchor = 'start', cssPropertiesToCopy = ['color', 'font-family', 'font-size', 'font-style', 'font-variant', 'font-weight', 'letter-spacing', 'opacity', 'text-transform'], htmlToSvgCssPropertyMap = {'color': 'fill', 'opacity': 'fill-opacity'}} = {}) {
        dstEl = dstEl.dom || dstEl;
        el = el.dom || el;

        var parent = el,
            prevCharLeft = el.getBoundingClientRect().left,
            text = dstEl.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'text')),
            tspan = null;

        forEachCodePoint(el, (codePoint, {textNode, codeUnitIndex}) => {
            var codePointRect = getCodePointRect(codePoint, {textNode, codeUnitIndex});

            if (!tspan || textNode.parentElement !== parent || codePointRect.left < prevCharLeft) {
                tspan = text.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'tspan'));

                tspan.setAttributeNS(null, 'dy', baselineOffset); 
                tspan.setAttributeNS(null, 'text-anchor', textAnchor);
                tspan.setAttributeNS(null, 'x', left + codePointRect.left - el.getBoundingClientRect().left);
                tspan.setAttributeNS(null, 'y', top + codePointRect.top - el.getBoundingClientRect().top);

                copyStyle(tspan, textNode.parentElement);
            }

            tspan.textContent += codePoint;

            parent = textNode.parentElement;
            prevCharLeft = codePointRect.left;
        });

        Array.from(text.querySelectorAll('tspan')).forEach(tspan => {
            tspan.setAttributeNS(null, 'textLength', tspan.getComputedTextLength());
        });

        return text;

        function copyStyle(dstEl, srcEl) {
            var srcStyle = getComputedStyle(srcEl);

            cssPropertiesToCopy.forEach(srcProperty => {
                var dstProperty = htmlToSvgCssPropertyMap[srcProperty] || srcProperty,
                    value = srcStyle.getPropertyValue(srcProperty),
                    priority = srcStyle.getPropertyPriority(srcProperty);

                dstEl.style.setProperty(dstProperty, value, priority);
            });
        }

        function getCodePointRect(codePoint, {textNode, codeUnitIndex}) {
            var range = document.createRange();

            range.setStart(textNode, codeUnitIndex);
            range.setEnd(textNode, codeUnitIndex + codePoint.length);

            return range.getBoundingClientRect();
        }

        function forEachCodePoint(el, callback) {
            var iterator = document.createNodeIterator(el, NodeFilter.SHOW_TEXT),
                textNode, codeUnitIndex;

            while (textNode = iterator.nextNode()) {
                codeUnitIndex = 0;

                SA.String.getCodePoints(textNode.nodeValue).forEach(codePoint => {
                    callback(codePoint, {textNode, codeUnitIndex});

                    codeUnitIndex += codePoint.length;
                });
            }
        }
    },

    renderWidget(dstEl, cfg, args) {
        var style = Object.assign({}, {position: 'absolute'}, cfg.style),
            widget = Ext.widget(Object.assign({renderTo: Ext.getBody()}, cfg, {style})),
            text = this.renderElement(dstEl, widget.getEl(), args);

        widget.destroy();

        return text;
    }
});